import { jsx as _jsx } from "react/jsx-runtime";
function brandStyle(brand) {
    if (!brand)
        return undefined;
    const style = {};
    if (brand.brandColor)
        style["--evolua-color-brand"] = brand.brandColor;
    if (brand.brandContrast) {
        style["--evolua-color-brand-contrast"] = brand.brandContrast;
    }
    if (brand.brandHover)
        style["--evolua-color-brand-hover"] = brand.brandHover;
    if (brand.brandMuted)
        style["--evolua-color-brand-muted"] = brand.brandMuted;
    return style;
}
/** Wrapper de tema claro + marca por tenant (white-label). */
export function ThemeProvider({ children, brand, className }) {
    return (_jsx("div", { "data-evolua-theme": "light", className: className, style: brandStyle(brand), children: children }));
}
//# sourceMappingURL=ThemeProvider.js.map